<template>
  <div>
    <div class="search-box btn3" :class="{ close: !searchMore }">
      <div class="input-item">
        <span class="label">保单号</span>
        <Input type="text" v-model="searchParams.policyNo" clearable placeholder="请输入" />
      </div>

      <div class="input-item">
        <span class="label">保险公司</span>
        <Select v-model="searchParams.companyCode" placeholder="请选择" filterable clearable transfer>
          <Option v-for="(bean, i) in companyList" :key="i" :value="bean.code">{{ bean.name }}</Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">产品名称</span>
        <Select v-model="searchParams.productCode" clearable transfer filterable>
          <Option :value="item.productCode" v-for="(item, index) in productList" :key="index">{{ item.productCode }}/{{ item.productName }}</Option>
        </Select>
      </div>

      <div class="input-item select-two">
        <Select v-model="dateType" :transfer="true">
          <Option value="2">承保日期</Option>
          <Option value="1">投保日期</Option>
          <Option value="6">支付日期</Option>
          <Option value="3">生效日期</Option>
        </Select>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.date"
          @on-change="searchParams.date = $event"
        ></DatePicker>
      </div>

      <div class="input-item select-two">
        <Select v-model="dateType3" :transfer="true">
          <Option value="1">应收日期</Option>
          <Option value="2">宽限期满日</Option>
        </Select>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.date3"
          @on-change="searchParams.date3 = $event"
        ></DatePicker>
      </div>

      <div class="input-item">
        <span class="label">保单年度</span>
        <Input type="number" v-model="searchParams.commissionIndex" placeholder="请输入" />
      </div>

      <div class="input-item">
        <span class="label">交费期次</span>
        <Input type="number" v-model="searchParams.commissionPeriods" placeholder="请输入" />
      </div>

      <div class="input-item">
        <span class="label">保单状态</span>
        <Select v-model="searchParams.policyStatusList" clearable transfer multiple>
          <Option value="1">已承保</Option>
          <Option value="-1">已退保</Option>
          <Option value="0">已终止</Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">回执状态</span>
        <Select
          v-model="searchParams.receiptStatusList"
          clearable
          transfer
          multiple
          :disabled="searchParams.receiptStatusNull && searchParams.receiptStatusNull.length ? true : false"
        >
          <Option value="-1">无需回执</Option>
          <Option value="0">待回执</Option>
          <Option value="1">回执成功</Option>
          <Option value="2">回执失败</Option>
        </Select>
        <CheckboxGroup
          v-model="searchParams.receiptStatusNull"
          style="margin-left: 10px; width: 110px"
          @on-change="changeTimeNull($event, 'receiptStatusList')"
        >
          <Checkbox label="1">为空</Checkbox>
        </CheckboxGroup>
      </div>

      <div class="input-item">
        <Select v-model="dateType2" :transfer="true" style="width: 115px; min-width: 115px">
          <Option value="1">回执签收日期</Option>
          <Option value="2">回执回销日期</Option>
        </Select>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.date2"
          @on-change="searchParams.date2 = $event"
          :disabled="searchParams.dateTimeNull && searchParams.dateTimeNull.length ? true : false"
          class="date-picker"
        ></DatePicker>
        <CheckboxGroup v-model="searchParams.dateTimeNull" style="margin-left: 10px; width: 82px; min-width: 82px" @on-change="changeTimeNull($event, 'date2')">
          <Checkbox label="1">为空</Checkbox>
        </CheckboxGroup>
      </div>

      <div class="input-item">
        <span class="label">回访状态</span>
        <Select
          v-model="searchParams.verifyStatusList"
          clearable
          transfer
          multiple
          :disabled="searchParams.verifyStatusNull && searchParams.verifyStatusNull.length ? true : false"
        >
          <Option value="0">等待回访</Option>
          <Option value="1">回访成功</Option>
          <Option value="2">回访失败</Option>
          <Option value="3">无需回访</Option>
        </Select>
        <CheckboxGroup v-model="searchParams.verifyStatusNull" style="margin-left: 10px; width: 110px" @on-change="changeTimeNull($event, 'verifyStatusList')">
          <Checkbox label="1">为空</Checkbox>
        </CheckboxGroup>
      </div>

      <div class="input-item">
        <span class="label">回访日期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.verifyDate"
          @on-change="searchParams.verifyDate = $event"
          :disabled="searchParams.revisitTimeNull && searchParams.revisitTimeNull.length ? true : false"
        ></DatePicker>
        <CheckboxGroup v-model="searchParams.revisitTimeNull" style="margin-left: 10px; width: 110px" @on-change="changeTimeNull($event, 'verifyDate')">
          <Checkbox label="1">为空</Checkbox>
        </CheckboxGroup>
      </div>

      <div class="input-item">
        <span class="label">犹豫止期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.hesitateDate"
          @on-change="searchParams.hesitateDate = $event"
          :disabled="searchParams.hesitateTimeNull && searchParams.hesitateTimeNull.length ? true : false"
        ></DatePicker>
        <CheckboxGroup v-model="searchParams.hesitateTimeNull" style="margin-left: 10px; width: 110px" @on-change="changeTimeNull($event, 'hesitateDate')">
          <Checkbox label="1">为空</Checkbox>
        </CheckboxGroup>
      </div>

      <div class="input-item">
        <span class="label">退保日期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.refundDate"
          @on-change="searchParams.refundDate = $event"
          :disabled="searchParams.refundTimeNull && searchParams.refundTimeNull.length ? true : false"
        ></DatePicker>
        <CheckboxGroup v-model="searchParams.refundTimeNull" style="margin-left: 10px; width: 110px" @on-change="changeTimeNull($event, 'refundDate')">
          <Checkbox label="1">为空</Checkbox>
        </CheckboxGroup>
      </div>

      <div class="input-item">
        <span class="label">险种分类</span>
        <Select v-model="searchParams.themeIds" placeholder="请选择" clearable multiple filterable>
          <Option v-for="item in productThemeList" :key="item.id" :value="item.id" :label="item.name"> </Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">业务类别</span>
        <Select
          v-model="searchParams.sellType"
          placeholder="请选择"
          multiple
          :disabled="searchParams.sellTypeStatusNull && searchParams.sellTypeStatusNull.length ? true : false"
        >
          <Option value="1">网销产品</Option>
          <Option value="3">经代产品</Option>
        </Select>
        <CheckboxGroup v-model="searchParams.sellTypeStatusNull" style="margin-left: 10px; width: 110px" @on-change="changeTimeNull($event, 'sellType')">
          <Checkbox label="1">为空</Checkbox>
        </CheckboxGroup>
      </div>

      <div class="input-item">
        <span class="label">结算状态</span>
        <Select v-model="searchParams.settlementStatus" transfer placeholder="请选择" clearable>
          <Option value="1">已结算</Option>
          <Option value="0">未结算</Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">结算周期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.settlementDate"
          @on-change="searchParams.settlementDate = $event"
          :disabled="searchParams.settlementTimeNull && searchParams.settlementTimeNull.length ? true : false"
        ></DatePicker>
        <CheckboxGroup v-model="searchParams.settlementTimeNull" style="margin-left: 10px; width: 110px" @on-change="changeTimeNull($event, 'settlementDate')">
          <Checkbox label="1">为空</Checkbox>
        </CheckboxGroup>
      </div>

      <div class="input-item" v-if="userInfo.userType != 3">
        <span class="label">所属结算单</span>
        <Select
          v-model="searchParams.settlementReportId"
          clearable
          transfer
          filterable
          :disabled="searchParams.reportIdStatusNull && searchParams.reportIdStatusNull.length ? true : false"
        >
          <Option :value="item.id" v-for="(item, index) in settlementDocList" :key="index">{{ item.reportName }}</Option>
        </Select>
        <CheckboxGroup
          v-model="searchParams.reportIdStatusNull"
          style="margin-left: 10px; width: 125px"
          @on-change="changeTimeNull($event, 'settlementReportId')"
        >
          <Checkbox label="1">为空</Checkbox>
        </CheckboxGroup>
      </div>

      <div class="input-item">
        <span class="label">费用归属/机构</span>
        <Select placeholder="请选择" v-model="searchParams.owerIds" clearable filterable multiple :max-tag-count="1">
          <Option v-for="(item, i) in orgList" :key="i" :value="item.id">
            {{ item.name }}
          </Option>
        </Select>
      </div>

      <div class="input-item">
        <span slot="label" class="label" v-if="userInfo.userType != 3">
          是否已付款<span class="tip-icon">?</span>
          <div class="pop-tip">
            <span>是否已对机构付款</span>
            <div class="arrow"></div>
          </div>
        </span>
        <span class="label" v-else>是否已回款</span>
        <Select v-model="searchParams.paymentStatus" clearable transfer filterable v-if="userInfo.userType != 3">
          <Option value="1">已付款</Option>
          <Option value="0">未付款</Option>
        </Select>
        <Select v-model="searchParams.returnedStatus" clearable transfer filterable v-else>
          <Option value="1">已回款</Option>
          <Option value="0">未回款</Option>
        </Select>
      </div>

      <div class="input-item">
        <span slot="label" class="label">
          是否扣款记录<span class="tip-icon">?</span>
          <div class="pop-tip">
            <span>因退保等原因已扣除费用的记录</span>
            <div class="arrow"></div>
          </div>
        </span>
        <RadioGroup v-model="searchParams.isDeduct" @on-change="searchAjax">
          <Radio label="">全部</Radio>
          <Radio label="1">是</Radio>
          <Radio label="0">否</Radio>
        </RadioGroup>
      </div>

      <div class="input-item">
        <span class="label">费用类型</span>
        <Select v-model="searchParams.commissionStyles" clearable transfer multiple>
          <Option value="1">基础费用</Option>
          <Option value="2">后置费用</Option>
        </Select>
      </div>

      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">搜索</Button>
        <Button type="primary" ghost @click="resetSearch()">重置</Button>
        <Button type="primary" ghost v-if="searchMore" @click="searchMore = false"
          >收起
          <Icon type="ios-arrow-up" />
        </Button>
        <Button type="primary" ghost v-else @click="searchMore = true"
          >展开
          <Icon type="ios-arrow-down" />
        </Button>
      </div>
    </div>

    <div class="tools-box">
      <div class="statistics-container">
        <div class="statistics-item">
          <span class="dot"></span>
          <span>保单：</span>
          <span class="num">{{ statisticsData.policyNum }}件</span>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>保费：</span>
          <span class="num">{{ statisticsData.fee }}元</span>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>费用合计：</span>
          <span class="num">{{ statisticsData.commissionPrice }}元</span>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>已结算费用：</span>
          <span class="num">{{ statisticsData.settlementCommissionPrice }}元</span>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>未结算费用：</span>
          <span class="num">{{ statisticsData.noSettlementCommissionPrice }}元</span>
        </div>

        <div class="statistics-item" v-if="userInfo.userType == 3">
          <span class="dot"></span>
          <span>已回款费用：</span>
          <span class="num">{{ statisticsData.returnCommissionPrice }}元</span>
        </div>

        <div class="statistics-item" v-if="userInfo.userType == 3">
          <span class="dot"></span>
          <span>未回款费用：</span>
          <span class="num">{{ statisticsData.noReturnCommissionPrice }}元</span>
        </div>
      </div>
      <Button type="primary" ghost @click="exportExcel">导出</Button>
    </div>

    <div class="tableBox">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="settlementStatus">
          <div class="settlement-status">
            <span v-if="row.settlementStatus == 0" class="tag-settled">未结算</span>
            <span v-else class="tag-be">已结算</span>
          </div>
        </template>

        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="withholdingCommission(row, false)" v-if="row.commissionType != 5 && row.canDeduct == 1">扣款</span>
          <span
            class="table-btn"
            v-else-if="row.commissionType != 5 && row.commissionPeriods == 1 && row.isDeduct == 1 && row.settlementStatus == 0"
            @click="withholdingCommission(row, true)"
            >修改扣款</span
          >
          <span v-else-if="row.commissionType != 5 && row.isDeduct == 1 && row.settlementStatus == 1" class="disabled-btn">修改扣款</span>
          <span v-else>-</span>
        </template>
      </Table>
      <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
    </div>

    <insure-commission-modify ref="commissionModify" @success="getList"></insure-commission-modify>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import filter from '@/api/filter';
import insureCommissionModify from './components/insureCommissionModify';

export default {
  mixins: [pageTool, common],
  components: {
    insureCommissionModify
  },
  data() {
    let vm = this;
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      tabVal: '1',
      dateType: '2',
      dateType2: '1',
      dateType3: '1',
      searchParams: {
        sellType: [],
        isOrg: '1',
        type: '1'
      },
      statisticsData: {},
      settlementDocList: [],
      supplierList: [],
      companyList: [],
      productList: [],
      productThemeList: [],
      orgList: [],
      tableData: [],
      columns: [
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 160,
          fixed: 'left'
        },
        {
          title: '结算状态',
          align: 'center',
          minWidth: 120,
          slot: 'settlementStatus'
        },
        {
          title: '结算周期',
          align: 'center',
          minWidth: 220,
          render(h, params) {
            let settlementDate = params.row.settlementDate;
            return <span>{filter.filterTime(settlementDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '所属结算单/结算周期',
          align: 'center',
          minWidth: 220,
          render(h, params) {
            let settlementReportName = params.row.settlementReportName;
            let settlementDate = params.row.settlementDate;
            return (
              <div>
                <span>{settlementReportName}</span>
                <span>{settlementReportName && settlementDate ? '/' : ''}</span>
                <span>{settlementDate ? filter.filterTime(settlementDate, 'YYYY-MM-DD') : ''}</span>
              </div>
            );
          }
        },
        {
          align: 'center',
          minWidth: 130,
          render(h, params) {
            if (vm.userInfo.userType == 3) {
              let returnedStatus = params.row.returnedStatus;
              return <span>{returnedStatus == 0 ? '未回款' : '已回款'}</span>;
            } else {
              let paymentStatus = params.row.paymentStatus;
              return <span>{paymentStatus == 0 ? '未付款' : '已付款'}</span>;
            }
          },
          renderHeader: (h, params) => {
            if (vm.userInfo.userType == 3) {
              return (
                <div>
                  <span>是否已回款</span>
                </div>
              );
            } else {
              return (
                <div>
                  <span>是否已付款</span>
                  <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip min-width" transfer={true}>
                    <Icon style="color:#A8ADB7;margin-left:4px;" type="md-help-circle" />
                    <div slot="content">
                      <p>是否已对机构付款</p>
                    </div>
                  </Poptip>
                </div>
              );
            }
          }
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 160
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 280
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'insuranceName',
          minWidth: 300
        },
        {
          title: '最新状态',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            if (params.row.policyStatus == 1) {
              return <span>已承保</span>;
            } else if (params.row.policyStatus == 0) {
              return <span>已终止</span>;
            } else if (params.row.policyStatus == 2) {
              return <span>续保</span>;
            } else if (params.row.policyStatus == -1) {
              return <span>已退保</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '承保日期',
          align: 'center',
          key: 'insureTime',
          minWidth: 130,
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filter.filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回执回销日期',
          align: 'center',
          key: 'receiptDate',
          minWidth: 130,
          render(h, params) {
            let receiptDate = params.row.receiptDate;
            return <span>{filter.filterTime(receiptDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '生效日期',
          align: 'center',
          key: 'effectTime',
          minWidth: 130,
          render(h, params) {
            let effectTime = params.row.effectTime;
            return <span>{filter.filterTime(effectTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回访日期',
          align: 'center',
          key: 'revisitDate',
          minWidth: 130,
          render(h, params) {
            let revisitDate = params.row.revisitDate;
            return <span>{filter.filterTime(revisitDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '犹豫止期',
          align: 'center',
          key: 'hesitateDate',
          minWidth: 130,
          render(h, params) {
            let hesitateDate = params.row.hesitateDate;
            return <span>{filter.filterTime(hesitateDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '保障期',
          align: 'center',
          key: 'guaranteeDesc',
          minWidth: 120
        },
        {
          title: '交费期',
          align: 'center',
          key: 'payDesc',
          minWidth: 120
        },
        {
          title: '保单年度',
          align: 'center',
          key: 'commissionIndex',
          minWidth: 100
        },
        {
          title: '交费期次',
          align: 'center',
          key: 'commissionPeriods',
          minWidth: 100
        },
        {
          title: '应收日期',
          align: 'center',
          key: 'needPayDate',
          minWidth: 120,
          render(h, params) {
            let needPayDate = params.row.needPayDate;
            return <span>{needPayDate ? filter.filterTime(needPayDate, 'YYYY-MM-DD') : ''}</span>;
          }
        },
        {
          title: '实收/支付日期',
          align: 'center',
          key: 'payTime',
          minWidth: 130,
          render(h, params) {
            let payTime = params.row.payTime;
            return <span>{filter.filterTime(payTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '费用归属/机构',
          align: 'center',
          minWidth: 160,
          key: 'owerName'
        },
        {
          title: '费用归属内部组织编码',
          align: 'center',
          minWidth: 120,
          key: 'innerCode'
        },
        {
          title: '费用类型',
          align: 'center',
          key: 'commissionType ',
          minWidth: 160,
          render(h, params) {
            const commissionType = params.row.commissionType;
            if (commissionType == 1 || commissionType == 3 || commissionType == 7 || commissionType == 9) {
              return <span>基础费用</span>;
            } else if (commissionType == 5 || commissionType == 21) {
              return <span>后置费用</span>;
            }
          }
        },
        {
          title: '净费率',
          align: 'center',
          key: 'netCommission',
          minWidth: 100,
          render(h, params) {
            const netCommission = params.row.netCommission;
            return <span>{netCommission ? netCommission + '%' : '-'}</span>;
          }
        },
        {
          title: '净费用',
          align: 'center',
          key: 'netIncome',
          minWidth: 150,
          render(h, params) {
            const netIncome = params.row.netIncome;
            const deductType = params.row.deductType;
            let msg = '';
            if (deductType == 1) {
              msg = '退保';
            } else if (deductType == 2) {
              msg = '部分退保';
            } else if (deductType == 3) {
              msg = '退现价';
            } else if (deductType == 4) {
              msg = params.row.deductMsg;
            }
            let isDeduct = params.row.isDeduct;
            if (isDeduct == '1') {
              return (
                <div style="display:flex; align-items: center; justify-content: center;">
                  <span>{netIncome ? netIncome : '-'}</span>
                  <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip min-width" transfer={true}>
                    <span style="height:20px; width:34px; font-size: 12px; border: 1px solid #ffcf8e; background: #fff3e3; color: #ff7f00; margin-left: 5px; padding: 2px 2px; cursor: pointer;">
                      扣款
                    </span>
                    <div slot="content">
                      <p>{msg}</p>
                    </div>
                  </Poptip>
                </div>
              );
            } else {
              return <span>{netIncome ? netIncome : '-'}</span>;
            }
          }
        },
        {
          title: '投保人',
          align: 'center',
          key: 'holderName',
          minWidth: 120
        },
        {
          title: '出单业务员',
          align: 'center',
          key: 'salesmanName',
          minWidth: 150
        },
        {
          title: '出单团队',
          align: 'center',
          key: 'groupName',
          minWidth: 150
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 120,
          fixed: 'right'
        }
      ]
    };
  },

  activated() {
    if (this.userInfo.userType == 3) {
      this.columns = this.columns.filter(item => item.title != '操作' && item.title != '所属结算单/结算周期');
    } else {
      this.columns = this.columns.filter(item => item.title != '结算周期');
    }
    this.getList();
    this.getUserList();
    this.getBaosi();
    this.queryProduct();
    this.getProductTheme();
    this.getSettlementDocList();
    this.getStatistics();
  },

  methods: {
    searchAjax() {
      this.pageNum = 1;
      this.getList();
      this.getStatistics();
    },
    // 重置
    resetSearch() {
      this.searchParams = {};
      this.searchParams.sellType = [];
      this.searchParams.isOrg = '1';
      this.searchParams.type = '1';
      this.dateType = '2';
      this.dateType2 = '1';
      this.dateType3 = '1';
      this.searchAjax();
    },
    // 导出
    exportExcel() {
      if (!this.$units.pointAction('offline_82_1_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      if (this.total == '0') {
        this.$notice.error('无可导出数据');
        return;
      }
      let data = {
        ...this.parameter(),
        owerTypes: [1],
        sellType: this.parameter().sellType.length ? this.parameter().sellType.join('|') : ''
      };
      this.$units.downloadFile('/buz/commissionLog/exportByOrg', data, 'POST');
    },
    // 获取保司
    getBaosi() {
      this.$http({
        url: '/buz/insuranceCompany/read/all',
        type: 'POST',
        data: {
          companyType: '1'
        }
      }).then(res => {
        //赠险公司列表初始化
        this.companyList = res.data;
      });
    },
    // 产品
    queryProduct() {
      this.$http({
        url: '/buz/productBase/read/array',
        type: 'POST',
        data: {
          productCategory: 3
        }
      }).then(res => {
        this.productList = res.data;
      });
    },
    //险种分类
    getProductTheme() {
      this.$http({
        url: '/buz/productTheme/array/first',
        type: 'GET',
        data: {}
      }).then(res => {
        //赠险公司列表初始化
        this.productThemeList = res.data;
      });
    },
    // 所属结算单
    getSettlementDocList() {
      this.$http({
        url: '/buz/settlementReport/read/list',
        type: 'POST',
        data: { pageNo: 1, pageSize: 9999, type: 1 }
      }).then(res => {
        this.settlementDocList = res.data;
      });
    },
    // 获取当前机构业务员
    getUserList() {
      let orgId = this.userInfo.organId;
      this.$http({
        url: '/buz/organizationBase/queryList',
        type: 'POST',
        data: {}
      }).then(res => {
        if (this.userInfo.userType != 3) {
          this.orgList = res.data.filter(item => item.id != orgId);
        } else {
          this.orgList = res.data;
        }
      });
    },

    changeTimeNull(value, key) {
      this.searchParams[key] = '';
    },

    parameter() {
      let data = JSON.parse(JSON.stringify(this.searchParams));
      if (data.date && data.date[0]) {
        if (this.dateType == 1) {
          //投保日期
          data.holdTimeStart = data.date[0];
          data.holdTimeEnd = data.date[1];
        } else if (this.dateType == 2) {
          //承保日期
          data.insureTimeStart = data.date[0];
          data.insureTimeEnd = data.date[1];
        } else if (this.dateType == 3) {
          //生效日期
          data.effectTimeStart = data.date[0];
          data.effectTimeEnd = data.date[1];
        } else if (this.dateType == 6) {
          //支付日期
          data.payTimeStart = data.date[0];
          data.payTimeEnd = data.date[1];
        }
      }
      delete data.date;

      // 结算日期
      if (data.settlementDate && data.settlementDate[0]) {
        data.settlementDateStart = data.settlementDate[0];
        data.settlementDateEnd = data.settlementDate[1];
      }
      delete data.settlementDate;

      // 回访日期
      if (data.verifyDate && data.verifyDate[0]) {
        data.revisitDateStart = data.verifyDate[0];
        data.revisitDateEnd = data.verifyDate[1];
      }
      delete data.verifyDate;

      // 犹豫期止
      if (data.hesitateDate && data.hesitateDate[0]) {
        data.hesitateDateStart = data.hesitateDate[0];
        data.hesitateDateEnd = data.hesitateDate[1];
      }
      delete data.hesitateDate;

      if (data.date2 && data.date2[0]) {
        //回执签收日期
        if (this.dateType2 == 1) {
          data.receiptDate2Start = data.date2[0];
          data.receiptDate2End = data.date2[1];
        } else if (this.dateType2 == 2) {
          //回执回销日期
          data.receiptDateStart = data.date2[0];
          data.receiptDateEnd = data.date2[1];
        }
      }
      delete data.date2;
      if (data.dateTimeNull && data.dateTimeNull.length && this.dateType2 == 1) {
        data.receiptDate2IsNull = '1';
        delete data.receiptDate2Start;
        delete data.receiptDate2End;
        delete data.dateTimeNull;
      } else if (data.dateTimeNull && data.dateTimeNull.length && this.dateType2 == 2) {
        data.receiptDateIsNull = '1';
        delete data.receiptDateStart;
        delete data.receiptDateEnd;
        delete data.dateTimeNull;
      } else {
        delete data.dateTimeNull;
      }

      // 退保日期
      if (data.refundDate && data.refundDate[0]) {
        data.refundTimeStart = data.refundDate[0];
        data.refundTimeEnd = data.refundDate[1];
      }
      delete data.refundDate;

      if (data.refundTimeNull && data.refundTimeNull.length) {
        data.refundTimeIsNull = '1';
        delete data.refundTimeStart;
        delete data.refundTimeEnd;
        delete data.refundTimeNull;
      } else {
        delete data.refundTimeNull;
      }

      if (data.settlementTimeNull && data.settlementTimeNull.length) {
        data.settlementDateIsNull = '1';
        delete data.settlementDateStart;
        delete data.settlementDateEnd;
        delete data.settlementTimeNull;
      } else {
        delete data.settlementTimeNull;
      }

      // 所属结算单
      if (data.reportIdStatusNull && data.reportIdStatusNull.length) {
        data.settlementReportIdIsNull = '1';
        delete data.settlementReportId;
        delete data.reportIdStatusNull;
      } else {
        delete data.reportIdStatusNull;
      }

      if (data.date3 && data.date3[0]) {
        //应收日期
        if (this.dateType3 == 1) {
          data.needPayDateStart = data.date3[0];
          data.needPayDateEnd = data.date3[1];
        } else if (this.dateType3 == 2) {
          //宽限期满日
          data.lastPayDateStart = data.date3[0];
          data.lastPayDateEnd = data.date3[1];
        }
      }
      delete data.date3;

      if (data.revisitTimeNull && data.revisitTimeNull.length) {
        data.revisitDateIsNull = '1';
        delete data.revisitDateStart;
        delete data.revisitDateEnd;
        delete data.revisitTimeNull;
      } else {
        delete data.revisitTimeNull;
      }

      // 犹豫止期
      if (data.hesitateTimeNull && data.hesitateTimeNull.length) {
        data.hesitateDateIsNull = '1';
        delete data.hesitateDateStart;
        delete data.hesitateDateEnd;
        delete data.hesitateTimeNull;
      } else {
        delete data.hesitateTimeNull;
      }

      // 回执状态
      if (data.receiptStatusNull && data.receiptStatusNull.length) {
        data.isNullReceiptStatus = '1';
        delete data.receiptStatusList;
        delete data.receiptStatusNull;
      } else if (data.receiptStatusList == '') {
        delete data.receiptStatusList;
        delete data.receiptStatusNull;
      } else {
        delete data.receiptStatusNull;
      }

      // 回访状态
      if (data.verifyStatusNull && data.verifyStatusNull.length) {
        data.isNullVerifyStatus = '1';
        delete data.verifyStatusList;
        delete data.verifyStatusNull;
      } else if (data.verifyStatusList == '') {
        delete data.verifyStatusList;
        delete data.verifyStatusNull;
      } else {
        delete data.verifyStatusNull;
      }

      // 业务类别
      if (data.sellTypeStatusNull && data.sellTypeStatusNull.length) {
        data.sellTypeIsNull = '1';
        delete data.sellTypeStatusNull;
      } else if (data.sellType == '') {
        delete data.sellTypeStatusNull;
      } else {
        delete data.sellTypeStatusNull;
      }
      return data;
    },

    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/commissionLog/queryLogPage',
        type: 'POST',
        data: {
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          ...this.parameter(),
          owerTypes: [1],
          sellType: this.parameter().sellType.length ? this.parameter().sellType.join('|') : ''
        }
      })
        .then(res => {
          this.tableData = res.data;
          this.total = res.total;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
    // 统计
    getStatistics() {
      this.$http({
        url: '/buz/commissionLog/statistics',
        type: 'POST',
        data: {
          type: 1,
          ...this.parameter(),
          owerTypes: [1],
          sellType: this.parameter().sellType.length ? this.parameter().sellType.join('|') : ''
        }
      }).then(res => {
        this.statisticsData = res.data;
      });
    },
    // 扣款
    withholdingCommission(row, falg) {
      if (!this.$units.pointAction('offline_82_1_2')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$refs.commissionModify.open(row, falg);
    }
  }
};
</script>

<style lang="scss" scoped>
.search-box {
  margin-top: 20px;
  /deep/.select-two .ivu-select {
    width: 115px !important;
    min-width: 115px;

    .ivu-select-selection {
      border-right: 1px solid #dcdee2 !important;
    }
  }
}
/deep/.select-two .ivu-select {
  width: 115px !important;
  .ivu-select-selection {
    border-right: 1px solid #dcdee2 !important;
  }
}
.tools-box {
  display: flex;
  justify-content: space-between;
  .statistics-container {
    display: flex;
    margin: 10px 0;
    .statistics-item {
      display: flex;
      margin-right: 20px;

      .dot {
        width: 4px;
        height: 4px;
        background: #236dff;
        align-self: center;
        margin-right: 7px;
      }
      .num {
        color: #3c464f;
      }
    }
  }
  button {
    margin-left: auto;
  }
}
.dian {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #35bf3f;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: top;
  transform: translateY(7px);
  &.red {
    background: #e3461f;
  }
  &.orange {
    background: #ff9900 !important;
  }
}
.disabled-btn {
  cursor: no-drop;
  color: #c5c8ce;
}
.label {
  position: relative;
  .tip-icon {
    margin-left: 3px;
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background: transparent;
    border: 1px solid #9c9c9c;
    color: #a8a6a6;
    display: inline-block;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    cursor: pointer;
    top: 50%;
  }
  .tip-icon:hover + .pop-tip {
    opacity: 0.9;
    z-index: 9999;
    display: block;
  }
  .pop-tip {
    position: absolute;
    bottom: -40px;
    display: flex;
    align-items: center;
    text-align: left;
    left: 50%;
    margin-left: -0px;
    padding: 3px 10px;
    display: flex;
    flex-direction: column;
    background-color: #444444;
    display: none;
    border-radius: 4px;
    span {
      font-size: 12px;
      font-weight: 500;
      color: #fff;
    }
    .arrow {
      position: absolute;
      width: 12px;
      height: 12px;
      background-color: #444444;
      opacity: 0.9;
      top: -4px;
      left: 29px;
      transform: rotateZ(135deg);
    }
  }
}

.settlement-status {
  display: flex;
  .tag-settled {
    width: 55px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 2px;
    font-size: 13px;
    color: #e3461f;
    border: 1px solid #ffc1b2;
    background: #fff5f2;
  }
  .tag-be {
    width: 55px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 4px;
    font-size: 13px;
    color: #35bf3f;
    border: 1px solid #abeaae;
    background: #f6fcf4;
  }
}

.text-tag {
  margin-left: 5px;
  width: 34px;
  height: 20px;
  border-radius: 2px;
  font-size: 12px;
  color: #ff7f00;
  border: 1px solid #ffcf8e;
  background: #fff3e3;
}
</style>
